export enum Direction {
  horisontal = "horisontal",
  vertical = "vertical",
}
